import { mainApi } from '@/lib/api';
import type { PageOrderItem, SectionOrderItem } from '../types/myStore.types';

export async function updatePagesOrder(storeId: number, pages: PageOrderItem[]): Promise<void> {
    await mainApi.patch(`v1/stores/${storeId}/pages/order`, pages);
}

export async function updateSectionsOrder(storeId: number, sections: SectionOrderItem[]): Promise<void> {
    await mainApi.patch(`v1/stores/${storeId}/sections/order`, sections);
}

export async function updateSectionTitle(storeId: number, sectionId: number, title: string): Promise<void> {
    await mainApi.post(`v1/stores/section/${storeId}`, {
        section_id: sectionId,
        title: title,
    });
}

export async function deleteSection(storeId: number, sectionId: number): Promise<void> {
    await mainApi.patch(`v1/stores/${storeId}/sections`, {
        section_id: sectionId,
        status: 0,
    });
}
